import React, { useEffect } from "react";

import VideoPlayer from "../../components/Reusable/VideoPlayer";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const VideoEducationArchive = () => {
  const navigate = useNavigate();
  const { educationItemsList, educationVideo } = useSelector(
    (state) => state.educationReducer
  );
  const src = educationVideo;

  const handleEnded = () => {
    navigate("/lessons-archive");
  };

  return (
    <div className="video-education video-education-archive">
      <VideoPlayer src={src} onEnd={handleEnded} />
    </div>
  );
};

export default VideoEducationArchive;
